import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Text from '@ff/ui/Text';
import Icon from '@ff/ui/Icon';
import { isAppOnly } from '~/app/utils/pathUtils';
import PATHS from '~/app/utils/paths';

export default function FXFleetLayout({children}: {children: React.ReactNode}){
  const isApp = isAppOnly();
  const location = useLocation();
  const params = useParams();
  const { locale } = params;

  // Check if we're on the FX Fleet preorder page
  const isFXFleetPreorderPage = location.pathname === `/${locale}${PATHS.FX_FLEET_PREORDER}`;

  return isApp
    ?
    <>
      <H5Header />
      <main>
        {children}
      </main>
    </>
    : 
    <>
      {/* Custom FX Fleet Header */}
      <HeaderContainer isFixed={isFXFleetPreorderPage}>
        <HeaderContent>
          <LogoSection>
            <Icon name="ff-icon-ff-fx-icon-logo" fontSize="2rem" />
            <HeaderTitle>Faraday X Fleet</HeaderTitle>
          </LogoSection>
        </HeaderContent>
      </HeaderContainer>
      <main style={{ backgroundColor: 'white' }}>
        {children}
      </main>
    </>
}

const H5Header = styled(Box)(({ theme }) => ({
  height: '46px',
  position: 'fixed',
  top: '0px',
  left: '0px',
  zIndex: theme.zIndices.menubar
}));

const HeaderContainer = styled(Box)<{ isFixed?: boolean }>(({ theme, isFixed }) => ({
  backgroundColor: '#fff',
  borderBottom: '1px solid #e5e7eb',
  padding: '0 16px',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  ...(isFixed && {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  }),

  [theme.mediaQueries.md]: {
    padding: '0 24px',
  },
}));

const HeaderContent = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const LogoSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

const HeaderTitle = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '600',
  color: '#1f2937',

  [theme.mediaQueries.md]: {
    fontSize: '18px',
  },
}));